import { useRef } from "react";
import { createBooking } from "../lib/api";

function requestId() {
  // getRandomValues also works in older Instagram WebViews without randomUUID.
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function useBookingRequest() {
  const request = useRef(null);
  const pending = useRef(null);
  return (payload) => {
    if (pending.current) return pending.current;
    const signature = JSON.stringify(payload);
    if (request.current?.signature !== signature) request.current = { signature, id: requestId() };
    pending.current = createBooking(payload, request.current.id).finally(() => { pending.current = null; });
    return pending.current;
  };
}